import { render } from "./ViewAllProducts.vue?vue&type=template&id=e5059268&scoped=true"
import script from "./ViewAllProducts.vue?vue&type=script&lang=js"
export * from "./ViewAllProducts.vue?vue&type=script&lang=js"

import "./ViewAllProducts.vue?vue&type=style&index=0&id=e5059268&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5059268"]])

export default __exports__